import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

import fixture from '@/services/http/fixtures/fixture'
import childEditionFixture from '@/services/http/fixtures/childEdition'

export default {
  get(payload, assigned = false) {
    const endpoint = assigned ? 'childEditionAssigned' : 'childEdition'
    return fixture(childEditionFixture, () => http.get(endpoints.get(endpoint, { ...payload })))
  },
  getForCoordinator(payload) {
    return http.get(endpoints.get('childEditionForCoordinator', { ...payload }))
  },
  post(payload, childEditionId = null) {
    if (childEditionId) {
      return http.post(endpoints.get('childEdition', { childEditionId }), payload)
    }
    return http.post(endpoints.get('publicChildEdition'), payload)
  },
  publish(childEditionId) {
    return http.post(endpoints.get('publish', { childEditionId }))
  },
  changeSchool(payload) {
    return http.post(endpoints.get('changeSchool', { ...payload }), payload.data)
  },
  revokePublication(childEditionId) {
    return http.post(endpoints.get('revokePublication', { childEditionId }))
  },
  updatePersonalData(payload) {
    return http.post(endpoints.get('updatePersonalData', { ...payload }), payload.data)
  },
  updateGuardianData(payload) {
    return http.post(endpoints.get('updateGuardianData', { ...payload }), payload.data)
  },
  excludeChild(payload) {
    return http.post(endpoints.get('excludeChild', { ...payload }), payload.data)
  },
  includeAgainChild(childEditionId) {
    return http.post(endpoints.get('includeAgainChild', { ...childEditionId }))
  },
  getPaymentsList(childEditionId) {
    return http.get(endpoints.get('paymentsList', { childEditionId }))
  },
  getPesel(childEditionId) {
    return http.get(endpoints.get('pesel', { childEditionId }))
  },
  updatePesel(childEditionId, payload) {
    return http.post(endpoints.get('pesel', { childEditionId }), payload)
  },
  getNextEditionRecommendations(childEditionId, isCoordinator = false) {
    const endpoint = isCoordinator ? 'recommendationViewForCoordinator' : 'recommendationView'
    return http.get(endpoints.get(endpoint, { childEditionId }))
  }
}
